import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import RootRouter from './rootRoute';
import initSagas from './initSagas';
import configureStore, { sagaMiddleware, history } from './store';
import { ConnectedRouter } from 'connected-react-router'
import { DndProvider } from "react-dnd";
import Backend from "react-dnd-html5-backend";
import TouchBackend from 'react-dnd-touch-backend';

const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

const store = configureStore();

initSagas(sagaMiddleware);

ReactDOM.render(
    <Provider store={store} >
        <ConnectedRouter history={history}>
                <DndProvider backend={isStandalone ? TouchBackend : Backend}>
                    <RootRouter />
                </DndProvider>
        </ConnectedRouter>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

